// extracted by mini-css-extract-plugin
module.exports = {"map":"InternationalMap_map__W___7","country":"InternationalMap_country___jG2s","continent":"InternationalMap_continent__XXoAr"};